module.exports = __webpack_public_path__ + "static/awards-bg-36e83fb55afa9c37c21d8a8962c89de7.jpg";